import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const FilterProduct = createAsyncThunk(
  "filterProduct/FilterProduct",
  async (filterData, thunkAPI) => {
    try {
      const response = await axios.get(
        `${endPoint.FILTERPRODUCT}?${filterData?.name}=${filterData?.Catename}`
      );
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const FilterProductSlice = createSlice({
  name: "FilterProductData",
  initialState: {
    FilterProductData: [],
    error: null,
  },
  reducers: {
    clearFilterProductData: (state) => {
      state.FilterProductData = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(FilterProduct.fulfilled, (state, action) => {
        state.FilterProductData = action.payload;
      })
      .addCase(FilterProduct.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearFilterProductData } = FilterProductSlice.actions;
export default FilterProductSlice.reducer;
